// src/utils/loanMath.js
// Mirrors src/utils/loanCalculator.js on the backend.
// Live preview only — the server recomputes and snapshots on submit.
import { getRateForPurpose } from './loanRates';

const DEFAULT_RATE_PCT = 12;

const round2 = (n) => Math.round(n * 100) / 100;

export const calculateEmi = (principal, tenureMonths, ratePct = DEFAULT_RATE_PCT) => {
  const p = Number(principal);
  const n = Number(tenureMonths);
  if (!p || !n || p <= 0 || n <= 0) return null;

  const r = ratePct / 12 / 100;
  if (r === 0) return round2(p / n);

  const factor = (1 + r) ** n;
  return round2((p * r * factor) / (factor - 1));
};

export const calculateLoanSummary = ({ loanAmount, tenureMonths, monthlyIncome, loanPurpose }) => {
  const rate = getRateForPurpose(loanPurpose);
  const emi = calculateEmi(loanAmount, tenureMonths, rate); // ← pass the rate
  const income = Number(monthlyIncome);

  return {
    emi,
    totalInterest: emi === null ? null : round2(emi * Number(tenureMonths) - Number(loanAmount)),
    foirPct: emi && income > 0 ? round2((emi / income) * 100) : null,
    annualRatePct: rate // ← return the purpose-based rate
  };
};

// Indian numbering: ₹5,00,000 not ₹500,000
export const formatRupees = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(n);
};
